import { render, staticRenderFns } from "./QaReadWindow.vue?vue&type=template&id=c8b53e36&"
import script from "./QaReadWindow.vue?vue&type=script&lang=js&"
export * from "./QaReadWindow.vue?vue&type=script&lang=js&"
import style0 from "./QaReadWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports